import { ButtonProps } from '@chakra-ui/react';
import { FC, useRef } from 'react';
import { AriaButtonProps, useButton } from 'react-aria';
import { Button } from '../Button';

export interface FieldButtonProps extends AriaButtonProps<'button'> {
    sx?: ButtonProps['sx'];
}

export const FieldButton: FC<FieldButtonProps> = (props) => {
    const ref = useRef<HTMLButtonElement>(null);
    const { buttonProps } = useButton(props, ref);
    return (
        <Button
            ref={ref}
            variant="unstyled"
            size="sm"
            fontSize="md"
            sx={props.sx}
            onClickEvent="Date Picker Field Button Clicked"
            {...buttonProps}
        >
            {props.children}
        </Button>
    );
};
